
<div style="height: 150px;">
</div>
<section class="text-center px-8">
    <h2 class="text-gray-900 text-4xl tracking-tight font-extrabold sm:text-5xl">
        “Best practices” don’t actually work.
    </h2>
</section>

<div style="height: 100px;">
</div>


<div style="width:200px; text-align:center; margin:0 auto 0 auto;">
    <label for="trigger" style="cursor: pointer;" class="no-underline transform motion-reduce:transform-none hover:-translate-y-1 hover:scale-10 transition ease-in-out duration-300 bg-zinc-900 font-bold ml-4 py-3 px-3 rounded-lg">
        <span class="text-white">Try App for free</span>
    </label>
</div>
